/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Empty_CtaInputs */

const en_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track a Job`)
};

const de_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job tracken`)
};

const fr_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre un emploi`)
};

const es_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar un empleo`)
};

const it_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitora un lavoro`)
};

const nl_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg een baan`)
};

const pl_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledz oferte pracy`)
};

const fi_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraa työpaikkaa`)
};

const da_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spor et job`)
};

const sv_interview_empty_cta = /** @type {(inputs: Interview_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folj ett jobb`)
};

/**
* | output |
* | --- |
* | "Track a Job" |
*
* @param {Interview_Empty_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_empty_cta = /** @type {((inputs?: Interview_Empty_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Empty_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_empty_cta(inputs)
	if (locale === "fr") return fr_interview_empty_cta(inputs)
	if (locale === "es") return es_interview_empty_cta(inputs)
	if (locale === "it") return it_interview_empty_cta(inputs)
	if (locale === "nl") return nl_interview_empty_cta(inputs)
	if (locale === "pl") return pl_interview_empty_cta(inputs)
	if (locale === "fi") return fi_interview_empty_cta(inputs)
	if (locale === "da") return da_interview_empty_cta(inputs)
	if (locale === "sv") return sv_interview_empty_cta(inputs)
	return en_interview_empty_cta(inputs)
});